const hideWhenSiteIsFIT = variables => variables.selectedSites?.every(site => site.contract_id.includes("FIT"));
const hideWhenSelectedCountryIsNotAll = variables => variables.selectedCountry !== 'ALL'
const hideWhenSiteIsSolo = variables => variables.selectedSites?.every(site => site.solo);
const hideWhenClientAndSiteIsSolo = variables => variables.user?.roles?.includes("_CLIENT:Base") && variables.selectedSites?.every(site => site.solo);
const hideAllUsersExceptVN_OM = variables => !variables.user?.roles?.includes("administration:DataDownload:dailyIncidences:_view");
const hideWhenSiteIsNotBESS = variables => !variables.selectedSites?.some(site => site.is_BESS);
const hideWhenSiteIsNotPV = variables => variables.selectedSites?.some(site => site.is_no_PV);
const hideAllUsersExceptVN_OM_or_SiteIsNotPV = variables => !variables.user?.roles?.includes("administration:DataDownload:dailyIncidences:_view") || variables.selectedSites?.some(site => site.is_no_PV);

export default {
	hideWhenSiteIsFIT,
	hideWhenSelectedCountryIsNotAll,
	hideWhenSiteIsSolo,
	hideWhenClientAndSiteIsSolo,
	hideAllUsersExceptVN_OM,
	hideWhenSiteIsNotBESS,
	hideWhenSiteIsNotPV,
	hideAllUsersExceptVN_OM_or_SiteIsNotPV
};